import { ulid } from 'ulid';
import type { Clock } from './clock.js';

/**
 * Id provider port — injected identifier generation.
 *
 * WHY ULID: lexicographically sortable + time-ordered, so ids order events and
 * sort naturally. Injected (not ad-hoc `Math.random`) so tests are deterministic.
 */
export interface IdProvider {
  /** Generate a new unique, time-ordered id. */
  next(): string;
}

/** Production ULID provider, seeded by the injected clock for time ordering. */
export function createUlidProvider(clock: Clock): IdProvider {
  return {
    next: () => ulid(clock.now()),
  };
}
